import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import WorldMapPreview from "./render";


export const WorldMap = () => {
    const [copied, setCopied] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");

    const [backgroundColor, setBackgroundColor] = useState(queryParams.get("backgroundColor") || "EDEDED");
    const [width, setWidth] = useState(queryParams.get("width") || 0);
    const [height, setHeight] = useState(queryParams.get("height") || 0);
    const [zoom, setZoom] = useState(queryParams.get("zoom") || 12);
    const [address, setAddress] = useState(queryParams.get("address") || null);
    const [template, setTemplate] = useState(queryParams.get("template") || "manchester");

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/radarchart?na=1"
        + "&environment=PROD"
        + "&backgroundColor=" + backgroundColor
        + "&width=" + width
        + "&height=" + height
        + "&address=" + address
        + "&template=" + template
        + "&zoom=" + zoom
    ;




    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };



    return (
        <div className="flex flex-col items-center justify-center" style={{width:width===0 ? '100vw' : width,height:height===0 ? '100vh' : height , backgroundColor:backgroundColor}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Radar Chart Card Component
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Chart configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">


                    </div>
                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>


                    <br/><br/>
                </>)}

            <WorldMapPreview
                width={width}
                height={height}
                backgroundColor={backgroundColor}
                zoom={zoom}
                template={template}
                address={address}
            />


            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                            <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>
                        <Link to={"/"}>
                            <button className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600" >
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
